/**
 * Deep links into Meta Ads Manager for a given ad account.
 *
 * Ad account ids reach us `act_`-prefixed (Graph `/me/adaccounts` returns them
 * that way), while Ads Manager URLs take the bare numeric id in `act`. Stripping
 * the prefix here keeps that detail in one place instead of at every call site.
 */
const BILLING_SETTINGS_URL =
  'https://www.facebook.com/ads/manager/account_settings/account_billing/';

/** The bare numeric id Ads Manager URLs expect, from an `act_`-prefixed id. */
export const bareAdAccountId = (adAccountId: string): string =>
  adAccountId.trim().replace(/^act_/, '');

/**
 * Billing settings of a single ad account: where a brand adds the payment
 * method Meta requires before the account can spend. Null for a blank id, so a
 * caller renders no link rather than one pointing at nothing.
 */
export const metaAdsBillingUrl = (adAccountId: string | null | undefined): string | null => {
  if (!adAccountId) {
    return null;
  }

  const account = bareAdAccountId(adAccountId);

  return account ? `${BILLING_SETTINGS_URL}?act=${encodeURIComponent(account)}` : null;
};
